import React from "react";
import OrderList from "./orderlist";
import PickupOrders from "../FulfillmentPartner/PickupOrders";
import "./orderDashboard.css";

const MEDICINE_ORDERS_PATH = "/admin/order_list";
const PICKUP_ORDERS_PATH = "/admin/pickup-orders";

const OrderDashboard = (props) => {
  const showPickupOrders = props.location.pathname === PICKUP_ORDERS_PATH;

  const openSection = (path) => {
    if (props.location.pathname !== path) {
      props.history.push(path);
    }
  };

  return (
    <div className="order-dashboard">
      <div
        className="order-dashboard-nav"
        role="tablist"
        aria-label="Order sections"
      >
        <button
          type="button"
          role="tab"
          aria-selected={!showPickupOrders}
          className={`order-dashboard-tab ${
            !showPickupOrders ? "is-active" : ""
          }`}
          onClick={() => openSection(MEDICINE_ORDERS_PATH)}
        >
          <i className="fa fa-medkit" aria-hidden="true" />
          Medicine Orders
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={showPickupOrders}
          className={`order-dashboard-tab ${
            showPickupOrders ? "is-active" : ""
          }`}
          onClick={() => openSection(PICKUP_ORDERS_PATH)}
        >
          <i className="fas fa-walking" aria-hidden="true" />
          Pickup Orders
        </button>
      </div>

      <div role="tabpanel">
        {showPickupOrders ? (
          <PickupOrders {...props} />
        ) : (
          <OrderList {...props} />
        )}
      </div>
    </div>
  );
};

export default OrderDashboard;
